import type { QueryClient } from "@tanstack/react-query";
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
  Scripts,
  useRouter,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import type { ReactNode } from "react";

import { AppProviders } from "@/components/providers/app-providers";
import { getQueryClient } from "@/lib/query-client";
import appCss from "@/styles.css?url";

type MyRouterContext = {
  queryClient: QueryClient;
};

export const Route = createRootRouteWithContext<MyRouterContext>()({
  head: () => ({
    meta: [
      {
        charSet: "utf-8",
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      },
      {
        title: "Spinner",
      },
    ],
    links: [
      {
        rel: "stylesheet",
        href: appCss,
      },
    ],
  }),

  component: () => {
    const router = useRouter();
    const queryClient = router.options.context?.queryClient ?? getQueryClient();

    return (
      <RootDocument>
        <AppProviders queryClient={queryClient}>
          <Outlet />
          <TanStackRouterDevtools position="bottom-right" />
        </AppProviders>
      </RootDocument>
    );
  },
});

function RootDocument({ children }: { children: ReactNode }) {
  return (
    <html lang="en">
      <head>
        <HeadContent />
      </head>
      <body suppressHydrationWarning>
        {children}
        <Scripts />
      </body>
    </html>
  );
}
